import { useMemo } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { sortByGifts } from "@jti/commerce/shared";
import type { OrderItem } from "@jti/magento";

import type { SummaryItem } from "../../ItemsSummaryView";
import { mapOrderItemToSummaryItem } from "../../utils/mapOrderItemToSummaryItem";

export const useOrderItemsMappedToSummaryItems = (items: readonly OrderItem[] | null = []) => {
  const {
    displayBundleSelectedItems,
    displayBundleSelectedItemsPrices,
    showPricesWithTaxExcluded = false,
  } = useConfig();

  const mappedItems = useMemo(() => {
    if (!items || items?.length === 0) {
      return [];
    }

    return [...items]
      .sort(sortByGifts)
      .map((orderItem: OrderItem) =>
        mapOrderItemToSummaryItem(
          orderItem,
          displayBundleSelectedItems,
          displayBundleSelectedItemsPrices,
          showPricesWithTaxExcluded
        )
      )
      .filter((item): item is SummaryItem => item !== null);
  }, [items, displayBundleSelectedItems, displayBundleSelectedItemsPrices, showPricesWithTaxExcluded]);

  return { summaryItems: mappedItems };
};
